/**
 * @generated SignedSource<<bbad41e094d2da43f6ada1b30f19374d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespIconBubbleShare_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedIconBubbleEmail_item" | "PdpSharedIconBubbleFacebook_item" | "PdpSharedIconBubblePinterest_item">;
  readonly " $fragmentType": "PdpRespIconBubbleShare_item";
};
export type PdpRespIconBubbleShare_item$key = {
  readonly " $data"?: PdpRespIconBubbleShare_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespIconBubbleShare_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespIconBubbleShare_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedIconBubblePinterest_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedIconBubbleFacebook_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedIconBubbleEmail_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "91d0648af64e9a06f88f9a1bdcf4e115";

export default node;
